const UnassignedStore = () => import(/* webpackChunkName: "UnassignedStore" */ '@/views/UnassignedStore')
const UnassignedRecord = () => import(/* webpackChunkName: "UnassignedRecord" */ '@/views/UnassignedStore/unassignedRecord')
const TransferAssign = () => import(/* webpackChunkName: "TransferAssign" */ '@/views/UnassignedStore/transferAssign')
const unassignedStoreRouter = [
  {
    // path: '', 或者 重定向
    path: '/unassignedStore',
    component: UnassignedStore,
    meta: { // 给路由对象添加额外的信息
      scrollY: 0,
      title: 'Unassigned Store'
    }
  },
  {
    path: '/unassignedStore/unassignedRecord',
    component: UnassignedRecord,
    meta: {
      title: 'Unassigned Record'
    }
  },
  {
    path: '/unassignedStore/transferAssign',
    component: TransferAssign,
    meta: {
      title: 'Transfer Assign'
    }
  }
]

export default unassignedStoreRouter
